export default __webpack_public_path__ + "static/media/pic_logo.7ac2f36e.png";